import { Navigate, Route, Routes, useLocation } from "react-router";
import { AppShell } from "./components/AppShell";
import { useSession } from "./lib/session";
import { AdminPage } from "./pages/AdminPage";
import { DeckDetailPage } from "./pages/DeckDetailPage";
import { DecksPage } from "./pages/DecksPage";
import { GameDetailPage } from "./pages/GameDetailPage";
import { GamesPage } from "./pages/GamesPage";
import { LeaderboardPage } from "./pages/LeaderboardPage";
import { LoginPage } from "./pages/LoginPage";
import { OverviewPage } from "./pages/OverviewPage";
import { SeasonsPage } from "./pages/SeasonsPage";
import { SettingsPage } from "./pages/SettingsPage";
import { UploadPage } from "./pages/UploadPage";

function Protected({ children }: { children: React.ReactElement }) {
  const { user, loading } = useSession();
  const location = useLocation();
  if (loading) return <div className="pr-empty">Loading…</div>;
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  return children;
}

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        element={
          <Protected>
            <AppShell />
          </Protected>
        }
      >
        <Route index element={<OverviewPage />} />
        <Route path="upload" element={<UploadPage />} />
        <Route path="games" element={<GamesPage />} />
        <Route path="games/:gameId" element={<GameDetailPage />} />
        <Route path="decks" element={<DecksPage />} />
        <Route path="decks/:deckId" element={<DeckDetailPage />} />
        <Route path="leaderboard" element={<LeaderboardPage />} />
        <Route path="seasons" element={<SeasonsPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="admin" element={<AdminPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
